import getSpotinaryUrl from './get-spotinary-url';
import { getSafariVersion } from './browser-detect';

function getCloudinaryUrl(cloudinaryUrl) {
  return function getUrl(imageId, options) {
    if (!imageId) {
      return '';
    }

    options = Object.assign(
      {
        width: null,
        height: null,
        crop: null,
        opacity: null,
        blur: null,
        colorize: null,
        extension: null,
        radius: null,
        gravity: null,
        default: null
      },
      options
    );

    if (imageId.startsWith('spotim-user')) {
      return getSpotinaryUrl(imageId, options);
    }

    // remove for the demos
    var attrs = ['f_auto', 'q_70', 'fl_lossy'];

    //side step cloudinary bug on Safari 8/9 with f_auto
    if (getSafariVersion() < 10) {
      let index = attrs.indexOf('f_auto');
      attrs.splice(index, 1);
    }

    // var attrs = [];
    var extension = options.extension ? '.' + options.extension : '';
    var attrsStr, url;
    attrs.push('dpr_' + (options.ratio || '3.0'));

    if (options.height) {
      attrs.push('h_' + formatSize(options.height));
    }

    if (options.width) {
      attrs.push('w_' + formatSize(options.width));
    }

    if (options.crop) {
      attrs.push('c_' + options.crop);
    }

    if (options.blur) {
      attrs.push('e_blur:' + options.blur);
    }

    if (options.opacity) {
      attrs.push('o_' + options.opacity);
    }

    if (options.radius) {
      attrs.push('r_' + options.radius);
    }

    if (options.gravity) {
      attrs.push('g_' + options.gravity);
    }

    if (options.default) {
      attrs.push('d_' + options.default);
    }

    if (options.colorize) {
      var color = options.colorize.replace(/#/g, '');
      attrs.push('e_colorize');
      attrs.push('co_rgb:' + color);
    }

    attrsStr = '/' + (attrs.length > 0 ? attrs.join(',') : '');
    url = cloudinaryUrl + attrsStr + '/v200/' + imageId + extension;

    return url;
  };

  function formatSize(size) {
    return Math.ceil(size * 1);
  }
}

export default getCloudinaryUrl;
